var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"p alert"},[_c('svgIcon',{attrs:{"iconClass":"general_alert","size":"20px"}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }